
export default {
  data () {
    return {
      leftSidebarVal: false
    }
  },
  methods: {
    left_sidebar () {
      this.leftSidebarVal = true
    },
    closeBarValFromChild (val) {
      this.leftSidebarVal = val
    }
  }
}
